import React, { memo, useEffect, useState, useCallback, Fragment } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import {
  DeleteDialog,
  Grid,
  Box,
  ErrorButtonOutlined,
  PrimaryButtonContained,
} from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { getDns, saveDns, deleteDns, updateDns } from "../../../actions/dns";
import { notify } from "../../../actions/notification";
import Typography from "@material-ui/core/Typography";
import { KeyboardTimePicker } from "@material-ui/pickers";

function ManageDns() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { paid } = useSelector((state) => state.storage);
  const { email: createdBy } = useSelector((state) => state.user);
  const { errors = {} } = useSelector((state) => (state.dns ? state.dns : {}));
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [openDeleteDailog, setOpenDeleteDailog] = useState(false);
  const [localState, setLocalState] = useState({
    oldDns: {},
    newDns: {},
  });

  const dns = useSelector((state) => state.dns);
  useEffect(() => {
    setStartTime(dns?.startAt);
    setEndTime(dns?.endAt);
    setLocalState({ ...localState, oldDns: dns, newDns: dns });
  }, [dispatch, dns, paid]);

  const handleStartTimeChange = (date) => {
    setStartTime(date);
    setLocalState({
      ...localState,
      newDns: { ...localState.newDns, startAt: date },
    });
  };
  const handleEndTimeChange = (date) => {
    setEndTime(date);
    setLocalState({
      ...localState,
      newDns: { ...localState.newDns, endAt: date },
    });
  };

  const setDns = useCallback(async () => {
    if (
      startTime &&
      endTime &&
      _.isEqual(localState.oldDns, localState.newDns)
    ) {
      dispatch(
        notify({
          type: "error",
          message: "You haven't made any changes!",
        })
      );
    } else {
      try {
        if (localState.newDns?._id) {
          await dispatch(
            updateDns({ startAt: startTime, endAt: endTime, paid, createdBy })
          );
        } else {
          await dispatch(
            saveDns({
              startAt: startTime,
              endAt: endTime,
              paid,
              createdBy,
            })
          );
        }
        await dispatch(getDns(paid));
      } catch (err) {
        if (err.message?.indexOf("400") === -1) {
          dispatch(
            notify({
              type: "error",
              message: err.message,
            })
          );
        }
      }
    }
  }, [dispatch, startTime, endTime]);

  const removeDns = useCallback(async () => {
    try {
      await dispatch(deleteDns(paid));
      setStartTime(null);
      setEndTime(null);
      setOpenDeleteDailog(false);
      await dispatch(getDns(paid));
    } catch (err) {
      if (err.message?.indexOf("400") === -1) {
        dispatch(
          notify({
            type: "error",
            message: err.message,
          })
        );
      }
    }
  }, [dispatch, startTime, endTime]);

  return (
    <Fragment>
      {dns && (
        <Grid container spacing={4} direction="row" align="center">
          <Grid item>
            <Box sx={{ width: "100%" }}>
              <Typography gutterBottom variant="h4" align="center" fullWidth>
                SMS
              </Typography>
            </Box>
          </Grid>

          <Grid item>
            <Box sx={{ width: "100%" }}>
              <KeyboardTimePicker
                label={t("Start Time")}
                format="hh:mm a"
                value={startTime ? startTime : null}
                onChange={handleStartTimeChange}
                fullWidth
                style={{ marginBottom: "1rem" }}
                error={Boolean(errors["startAt"])}
                helperText={
                  Boolean(errors["startAt"]) ? t("must not be empty") : ""
                }
                name="dns-start-time"
                KeyboardButtonProps={{ size: "small", color: "primary" }}
              />
            </Box>
          </Grid>

          <Grid item>
            <Box sx={{ width: "100%" }}>
              <KeyboardTimePicker
                label={t("End Time")}
                format="hh:mm a"
                value={endTime ? endTime : null}
                onChange={handleEndTimeChange}
                fullWidth
                style={{ marginBottom: "1rem" }}
                error={Boolean(errors["endAt"])}
                helperText={
                  Boolean(errors["endAt"]) ? t("must not be empty") : ""
                }
                name="dns-end-time"
                KeyboardButtonProps={{ size: "small", color: "primary" }}
              />
            </Box>
          </Grid>

          <Grid item>
            <Box sx={{ width: "100%" }}>
              <ErrorButtonOutlined
                onClick={() => {
                  setOpenDeleteDailog(true);
                }}
                disabled={!startTime || !endTime}
                fullWidth
                data-test-id="remove-dns-button"
              >
                Remove SMS
              </ErrorButtonOutlined>
            </Box>
          </Grid>
          <Grid item>
            <Box sx={{ width: "100%" }}>
              <PrimaryButtonContained
                onClick={setDns}
                data-test-id="set-dns-button"
                fullWidth
              >
                Update SMS
              </PrimaryButtonContained>
            </Box>
          </Grid>
        </Grid>
      )}
      <DeleteDialog
        open={openDeleteDailog}
        onClose={() => {
          setOpenDeleteDailog(false);
        }}
        onDelete={removeDns}
        name={`the DND setting`}
      />
    </Fragment>
  );
}

export default memo(ManageDns);
